export default {
  API_URL: 'https://api.painel.castelatto.com.br/',
};
